import { ModelType } from 'graphql-ts-client-api'
import { createRequestBuilder } from '../../Requests/RequestParam'
import { category$, category$$, categoryPage$, randomMedia$$, randomMediaPage$ } from '../../__generated/media-store/fetchers'
import { TYtVideosFilterParam, TCategoriesFilterParam, TPricePackage } from './types'
import { query$, mediaStoreGraphDbContext$ } from '../../__generated/media-store/fetchers'
import { youtubeVideo$$, youtubeVideoPage$ } from '../../__generated/media-store/fetchers'
import { pricePackage$$, pricePackagePage$ } from '../../__generated/media-store/fetchers'
import { media$$, mediaPage$ } from '../../__generated/media-store/fetchers'

const CategorySelector = category$$
const YoutubeVideoSelector = youtubeVideo$$
const PricePackageSelector = pricePackage$$

export const ExploreInitial = (ytVideosParam: TYtVideosFilterParam, categoriesParam: TCategoriesFilterParam) => {
  const YoutubeVideoPage = youtubeVideoPage$.items(YoutubeVideoSelector).hasNextPage.hasPreviousPage.totalItems
  const CategoryPage = categoryPage$.items(CategorySelector).hasNextPage.hasPreviousPage.totalItems
  const PricePackagePage = pricePackagePage$.items(pricePackage$$).hasNextPage.hasPreviousPage.totalItems
  const pricePackageFilter = createRequestBuilder<TPricePackage>({ ignoreEmpty: true })
    .filterEnum('type', 'Media')
    .sort('price', { direction: 'ASC' })
  return query$.mediaStore(
    mediaStoreGraphDbContext$
      .youtubeVideos(ytVideosParam, YoutubeVideoPage)
      .categories(categoriesParam, CategoryPage)
      .pricePackages(pricePackageFilter.build(), PricePackagePage)
  )
}

export const ExploreMediaCounts = () => {
  const YoutubeVideoPage = youtubeVideoPage$.totalItems
  return query$.mediaStore(mediaStoreGraphDbContext$.youtubeVideos({}, YoutubeVideoPage))
}

export const Explore = (ytVideosParam: TYtVideosFilterParam, categoriesParam: TCategoriesFilterParam) => {
  const YoutubeVideoPage = youtubeVideoPage$.items(YoutubeVideoSelector).hasNextPage.hasPreviousPage.totalItems
  const CategoryPage = categoryPage$.items(CategorySelector).hasNextPage.hasPreviousPage.totalItems
  return query$.mediaStore(mediaStoreGraphDbContext$.youtubeVideos(ytVideosParam, YoutubeVideoPage).categories(categoriesParam, CategoryPage))
}

interface IProductDetailParam {
  resourceId: string
  categories: TCategoriesFilterParam
  ytVideos: TYtVideosFilterParam
}

export const ProductDetailById = (param: IProductDetailParam) => {
  const YoutubeVideoPage = youtubeVideoPage$.items(YoutubeVideoSelector).hasNextPage.hasPreviousPage.totalItems
  const PricePackagePage = pricePackagePage$.items(PricePackageSelector).hasNextPage.hasPreviousPage.totalItems
  const CategoryPage = categoryPage$.items(CategorySelector).hasNextPage.hasPreviousPage.totalItems
  const pricePackageFilter = createRequestBuilder<TPricePackage>({ ignoreEmpty: true })
    .filterEnum('type', 'Media')
    .sort('price', { direction: 'ASC' })
  return query$.mediaStore(
    mediaStoreGraphDbContext$
      .youtubeVideo({ id: param.resourceId }, YoutubeVideoSelector)
      .youtubeVideos(param.ytVideos, YoutubeVideoPage)
      .categories(param.categories, CategoryPage)
      .pricePackages(pricePackageFilter.build(), PricePackagePage)
  )
}

// with media
const MediaSelector = media$$.categories(category$.name)
export type TExploreMedia = ModelType<typeof MediaSelector>
type TMediasFilterParam = Parameters<typeof mediaStoreGraphDbContext$.medias>[0]

export const ExplorePageWithMedia = (mediasParams: TMediasFilterParam, categoriesParam: TCategoriesFilterParam) => {
  const MediaPage = mediaPage$.items(MediaSelector).hasNextPage.hasPreviousPage.totalItems
  const CategoryPage = categoryPage$.items(CategorySelector).hasNextPage.hasPreviousPage.totalItems
  const PricePackagePage = pricePackagePage$.items(pricePackage$$).hasNextPage.hasPreviousPage.totalItems
  const pricePackageFilter = createRequestBuilder<TPricePackage>({ ignoreEmpty: true })
    .filterEnum('type', 'Media')
    .sort('price', { direction: 'ASC' })
  return query$.mediaStore(
    mediaStoreGraphDbContext$
      .medias(mediasParams, MediaPage)
      .categories(categoriesParam, CategoryPage)
      .pricePackages(pricePackageFilter.build(), PricePackagePage)
  )
}

export const ExploreCountWithMedia = () => {
  const filter = createRequestBuilder<TPricePackage>({ ignoreEmpty: true }).filterEnum('type', 'MediaType.Video')
  return query$.mediaStore(mediaStoreGraphDbContext$.medias(filter.build(), mediaPage$.totalItems))
}

export const ExploreFilterWithMedia = (mediasParam: TMediasFilterParam, categoriesParam: TCategoriesFilterParam) => {
  const MediaPage = mediaPage$.items(MediaSelector).hasNextPage.hasPreviousPage.totalItems
  const CategoryPage = categoryPage$.items(CategorySelector).hasNextPage.hasPreviousPage.totalItems
  return query$.mediaStore(mediaStoreGraphDbContext$.medias(mediasParam, MediaPage).categories(categoriesParam, CategoryPage))
}

interface IExploreMediaDetailByIdParam {
  id: string
  categories: TCategoriesFilterParam
}

const RandomMediaSelector = randomMedia$$.categories(category$.name)

export const ExploreMediaDetailById = (param: IExploreMediaDetailByIdParam) => {
  const MediaPage = randomMediaPage$.items(RandomMediaSelector).hasNextPage.hasPreviousPage.totalItems
  const PricePackagePage = pricePackagePage$.items(PricePackageSelector).hasNextPage.hasPreviousPage.totalItems
  const CategoryPage = categoryPage$.items(CategorySelector).hasNextPage.hasPreviousPage.totalItems
  const pricePackageFilter = createRequestBuilder<TPricePackage>({ ignoreEmpty: true })
    .filterEnum('type', 'Media')
    .sort('price', { direction: 'ASC' })
  const mediasRequest = createRequestBuilder<any>({ ignoreEmpty: true }).take(12).filterCustom('type==MediaType.Video')

  return query$.mediaStore(
    mediaStoreGraphDbContext$
      .media({ id: param.id }, MediaSelector)
      .randomMedias(mediasRequest.build(), MediaPage)
      .categories(param.categories, CategoryPage)
      .pricePackages(pricePackageFilter.build(), PricePackagePage)
  )
}
